define('views/modals/assign',['require','backbone','marionette','jquery-validation','collections/reseller_products','views/components/reseller_product_modal/reseller_products','text!templates/modals/assign.html'],function(require){

    var Backbone = require('backbone');
    require('marionette');
    require('jquery-validation');

    var ResellerProductsCollection = require('collections/reseller_products');
    var ModalResellerProductsView = require('views/components/reseller_product_modal/reseller_products');


    var temp = require("text!templates/modals/assign.html");

    return Backbone.Marionette.LayoutView.extend({
        template: _.template(temp),
        className: 'modal fade slide-up',
        selectedCustomer: null,
        licensesRender: function(){},

        initialize: function (options) {
            this.selectedCustomer = options.selectedCustomer;
            this.licensesRender = options.licensesRender;

            this.productsCollection = new ResellerProductsCollection([], {
                parameters: {
                    'limit': 1000
                }
            });

            this.assignCounts = [];

            _.bindAll(this, 'teardown');
            _.bindAll(this, 'changeAssignCount');
        },

        ui: function() {
            return {
                assignButton: '#assign',
                cancelButton: '#cancel',
                assignCount: '#assign_count'

            };
        },
        regions: function() {
            return {
                LicensesContainer: ".license-list",
            };
        },

        events: {
            'click @ui.assignButton': 'assignButtonClicked',
            'click @ui.cancelButton': 'cancelButtonClicked',
            'change input': 'changeAssignCount'
        },

        onRender: function() {
            this.LicensesContainer.show(new ModalResellerProductsView({
                collection: this.productsCollection
            }));
        },

        onShow: function () {
            this.$el.modal();
        },

        show: function() {
            this.$el.modal('show');
            this.onShow();
        },

        teardown: function() {
            this.$el.data('modal', null);
            this.remove();
        },

        close: function () {
            this.$el.modal('hide');
        },

        assignButtonClicked: function () {
            var _this = this;

            if (this.selectedCustomer) {
                _this.ui.assignButton.addClass('loading');

                Promise.all(
                    this.assignCounts.map(function (assignCount) {
                        return $.ajax({
                            url: App.Config.apiBase + 'reseller-products/' + assignCount.licenseId + '/assign_license/',
                            method: 'post',
                            data: {
                                customer: _this.selectedCustomer,
                                count: assignCount.count
                            },
                            success: function () {
                                App.utils.showMessage('success', App.polyglot.t('license_assign_success', { name: assignCount.licenseName }));
                            },
                            error: function (xhr, ajaxOptions, thrownError) {
        
                                // Show error messages
                                if (xhr.responseJSON.errors) {
                                    for (var i = 0; i < xhr.responseJSON.errors.length; i++) {
                                        App.utils.showMessage('error', xhr.responseJSON.errors[i].message + " " + App.polyglot.t('license') + " : " + assignCount.licenseName);
                                    }
                                }
                            }
                        });
                    })
                ).finally(function () {
                    _this.ui.assignButton.removeClass('loading');
                    _this.licensesRender();
                    _this.close();
                });


            }
        },

        cancelButtonClicked: function () {
            this.close();
        },

        changeAssignCount: function (event) {

            var changedField = event.currentTarget;

            var licenseId =  $(changedField).attr('license_id');
            var licenseName =  $(changedField).attr('license_name');
            var assignCount = $(changedField).val();

            if (Number(assignCount)) {
                var notAdded = true;
                this.assignCounts.forEach(function (item) {
                    if (item.licenseId == licenseId) {
                        notAdded = false;
                        item.count = assignCount;
                    }
                }); 

                if (notAdded) {
                    this.assignCounts.push({ licenseId: licenseId, count: assignCount , licenseName: licenseName});
                }
            } else {
                this.assignCounts = this.assignCounts.filter(function (item) {
                    return item.licenseId != licenseId;
                });
            }
        }

    });
});

